// extracted by mini-css-extract-plugin
export default {"header":"modal-header_header__VgM11","title":"modal-header_title__BZJGZ","logo":"modal-header_logo__j-uYz"};